import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'

// import qs from 'qs'
import './assets/css/theme/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
// import './assets/css/icon.css';
// import './assets/fonts/iconfont.css';
import store from './config/store';//全局变量管理
import echarts from 'echarts'
import animated from 'animate.css' // npm install animate.css --save安装，在引入
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'Zz1TGIMjYrZnIubp3XDtldvibLk5GTq6'
})
Vue.use(animated)
Vue.use(ElementUI)
Vue.prototype.$echarts=echarts
Vue.config.productionTip = false

//路由拦截
// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
//     if (store.state.token) {  // 通过vuex state获取当前的token是否存在
//       next();
//     } else {
//       next({
//         path: '/login'
//       })
//     }
//   }
//   else {
//     next();
//   }
// })
// router.afterEach((to,from,next) => {
//   document.body.scrollTop =0;
//   document.documentElement.scrollTop = 0;
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//使用store
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js